import React, { useState } from 'react';
import { FaDesktop } from 'react-icons/fa';
import styles from './DesktopOnlyStep.module.css';
import BookDemoModal from '../../../components/UI/BookDemoModal';

// Final step for phone users who skip Amazon connect: no way into the dashboard
// from here, only a nudge to come back on a desktop (or book a demo).
const DesktopOnlyStep = () => {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  return (
    <div className={styles.box}>
      <div className={styles.content}>
        <span className={styles.iconTile}><FaDesktop /></span>

        <div className={styles.textBlock}>
          <span className={styles.eyebrow}>Almost there</span>
          <h2 className={styles.title}>EcomBuddha is built for desktop</h2>
          <p className={styles.subtitle}>
            Log in from a laptop or desktop to use EcomBuddha.
          </p>
        </div>

        <div className={styles.divider} />

        <div className={styles.demoBlock}>
          <p className={styles.demoText}>Want a walkthrough first?</p>
          <button type="button" className={styles.demoBtn} onClick={() => setIsDemoOpen(true)}>
            Book a free demo
          </button>
        </div>
      </div>
      <BookDemoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
    </div>
  );
};

export default DesktopOnlyStep;
